import { AppSubjectEnum } from '../../authz/enums/app-subject.enum';
import { CaslSubject } from '../../authz/decorators/casl-subject.decorator';
import { BaseStatsDto } from '../../base/dtos/base-stats.dto';

/**
 * Vehicle makes stats DTO
 */
@CaslSubject(AppSubjectEnum.VEHICLE)
export class VehicleMakesStatsDto extends BaseStatsDto {
}
